// extracted by mini-css-extract-plugin
export default {"terms":"Targets_terms__azWZu","title":"Targets_title__3zuIR","wrapper":"Targets_wrapper__TIorm","drawer":"Targets_drawer__hzopA"};